import moment from "moment";
import shmuhelper from "./shmu-helper";

export default
{
    legend: {
        enabled: true,
        layout: 'horizontal',
        align: 'center',
        symbolRadius: 0,
        itemMarginTop: 2,
        symbolHeight:12,
        margin: 5,
        padding: 5,
        itemStyle:{ fontSize:'9px', fontWeight:'normal'},

    },
    credits: {
        enabled:false
    },
    chart: {
        marginLeft: 70,
        marginRight: 20,
        height:'350px',
        spacingTop: 10,
        spacingBottom: 20,
        spacingRight: 10,
        zoomType: '',
        style: { fontFamily: 'Tahoma' },
        animation:false,
        // plotBackgroundColor: dataset.plotBackgrounColor,
        events: {
            // load: initGraph
        },


    },
    title: {
        text: 'Priebeh teplôt<br>v porovnaní s dlhodobými hodnotami',
        enabled: true,
        style: {
            fontSize: '14px',
            color: '#004fb0',
            margin: 0,
            useHTML:true
        }
    },
    subtitle: {
        text: null
    },
    xAxis: {
        title: { text:null },
        type: 'datetime',
        tickInterval: 30* 24 * 3600 * 1000,
        dateTimeLabelFormats: {day: '%e. %B'},
        tickWidth: 1,  gridLineWidth: 0,
        labels:{ style: { fontSize:'11px' },   rotation: 270, x:0, y:12},
        gridLineDashStyle: 'Dot',
        lineWidth: 2,
        crosshair: true,
        plotLines: [],


    },
    yAxis: {
        title: {
            text: 'Teplota vody [°C]',
            useHTML: true,
            style: { fontSize:'11px' },
        },
        tickInterval:1,
        minorTickInterval: 0.5,
        tickWidth: 1,  gridLineWidth: 0,
        animation:false,
        minPadding: 0,
        maxPadding: 0,
        plotLines: [],
        plotBands: [],

    },
    tooltip: {
        positioner: function () {
            return {
                x: this.chart.chartWidth - this.label.width, // right aligned
                y: 0 // align to title
            };
        },
        borderWidth: 0,
        backgroundColor: 'none',
        useHTML: true,
        formatter: function()
        {
            let ds_unit = this.series.options.unit;
            return '<span style="color:#000; font-size:10px; margin-right: 10px; display:block; float:right; text-align: right">' + moment.unix(this.x/1000).format('D.M.Y HH:mm') + '</span> <strong style="float:right; margin-right:10px; display:block; text-align: right">' + this.y + '°C</strong>';
        },
        headerFormat: '',
        shadow: false,
        style: {
            fontSize: '18px',
            // color: dataset.color
        },
        // valueDecimals: dataset.valueDecimals


    },
    plotOptions: {
        spline: {
            connectNulls: false,
            animation: false,
            states: {
                hover: {
                    lineWidthPlus: 0
                }
            }

        },
        area: {
            connectNulls: false,
            animation: false,
            fillOpacity:1,
            marker: {
                enabled: false,
                states: {
                    hover: {
                        enabled: false
                    }
                }

            },
            states: {
                hover: {
                    lineWidthPlus: 0
                }
            }


        },
        states:{
            hover:{
                enabled:true
            }
        },
        series: {
            states:{
                inactive: {
                    opacity: 1
                }
            },

        }
    },
    series: [
        {
            id: 'tvod',
            plotBackgrounColor: '#ffffff',
            name: 'Teplota vody',
            title: 'Teplota vody (°C)',
            type: 'spline',
            marker: {enabled: false},
            unit: ' °C',
            showInLegend: false,
            tooltip: {valueSuffix: '°C'},
            color: '#0015FF',
            tickInterval: 1,
            animation: false,
            data: []
        },
        {id:'ep_tvod_min', name:'dlhodobá maximálna teplota', title:'Maximálna teplota', type: 'line', marker: { enabled: false}, color:'rgba(217, 98, 2, 0.8)', animation:false, data:[] },
        {id:'ep_tvod_max', name:'dlhodobá minimálna teplota', title:'Minimálna teplota', type: 'line', marker: { enabled: false}, color:'rgba(217, 2, 2, 0.8)', animation:false, data:[] },

    ]
}